Event.on('Listing.fetchedData', function (data) {
    const $listingCount = $('.js-listing-count'),
        $catalogHeader = $('.js-catalog-header:visible');

    if ($catalogHeader.size() && typeof getUrlParameter(data.url, 'start') == 'undefined') {
        slideTo($catalogHeader, 25, 250);
    }

    if ($listingCount.size()) {
        const listingPlural = $listingCount.data('plural');
        $listingCount.html('/ ' + data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count));
    }

    setTimeout(function () {
        bLazy.revalidate();

        tippy('.js-tippy', {
            arrow: true
        });
    }, 250);
});

Event.on('Listing.changeView', function () {
    const $view = $('[name="filter[view]"]'),
        value = $view.val();

    $(".products")
        .removeClass("products--row")
        .removeClass("products--grid");
    $(".products").addClass("products--" + value);
});

Eshop.alert = function(msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: checkMedia('cxs,xs') ? 'bottom' : 'top'
        },
        gap: 2,
        delay: 4500,
        mouse_over: 'pause',
        offset: {
            y: checkMedia('cxs,xs') ? 15 : 105,
            x: 0
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
                    '<i class="ico ico-close" aria-hidden="true"></i>' +
                '</button>' +
                '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

Eshop.confirm = function(text, options, callback) {
    var settings = $.extend({
        title: text,
        text: "",
        type: false,
        showCancelButton: true,
        cancelButtonText: 'Zrušiť',
        confirmButtonColor: "#2A6FE5",
        confirmButtonText: "Ok",
        closeOnConfirm: true
    }, options);

    swal(settings, callback);
}

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    Event.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    Event.dispatch('FilterBubbles.added');
}

function showOverlay(time, allowScroll) {
    let $body = $('body'),
        bodyWidth = $body.innerWidth(),
        scrollbarWidth;

    if (typeof time == 'undefined') {
        time = 250;
    }

    $('.c-overlay').addClass('is-active');

    if (!allowScroll) {
        freezeScroll();
        $body.addClass('is-overlayed');
    }
}

function hideOverlay(time) {
    if (typeof time == 'undefined') {
        time = 250;
    }

    $('.c-overlay').removeClass('is-active');
    $('body').removeClass('is-overlayed');
    unfreezeScroll();
}
